// export default function _scrollbutton() {
//     /**
//      * Scroll button selector
//      * @const {string}
//      */
//     const SCROLL_BTN_SELECTOR = '.hero-banner__js-scroll-btn';

//     // Add event listener to the scroll button
//     function smpScrollTopBtn(selector) {
//         // On click of the scroll button, scroll banner out of the way to expose main content
//         selector.addEventListener('click', () => {
//             selector.scrollIntoView({
//                 behavior: 'smooth',
//             });
//         });
//     }

//     /**
//      * @const {boolean}
//      */
//     const scrollBtnExists = !!document.querySelector(SCROLL_BTN_SELECTOR);
//     // If the scollBtn Exists
//     if (scrollBtnExists) {
//         smpScrollTopBtn(document.querySelector(SCROLL_BTN_SELECTOR));
//     }
// }

// _scrollbutton();

// functionality for hero-banner-search
// similar implementation to modules/heroBanner-search/js/global.js

/**
 * Hero banner search component selector
 * @const {string}
 */
export const HERO_BANNER_SEARCH_SELECTOR =
    '[data-component="hero-banner-search"]';

export default function _heroBannerSearch() {
    /**
     * Main search body selector
     * @const {string}
     */
    const HERO_BANNER_SEARCH_BODY_SELECTOR = '.hero-banner-search';

    /**
     * Open action selector
     * @const {string}
     */
    const HERO_BANNER_SEARCH_INPUT_SELECTOR = '.hero-banner-search__input';

    /**
     * Open action selector
     * @const {string}
     */
    const HERO_BANNER_SEARCH_OPEN_ACTION_SELECTOR =
        '[data-click="hero-banner-search-open"]';

    /**
     * Open action selector
     * @const {string}
     */
    const HERO_BANNER_SEARCH_TOGGLE_ACTION_SELECTOR =
        '[data-click="hero-banner-search-toggle"]';

    /**
     * Close action selector
     * @const {string}
     */
    const HERO_BANNER_SEARCH_CLOSE_ACTION_SELECTOR =
        '[data-click="hero-banner-search-close"]';

    /**
     * Clear action selector
     * @const {string}
     */
    const HERO_BANNER_SEARCH_CLEAR_ACTION_SELECTOR =
        '[data-click="hero-banner-search-clear"]';

    /**
     * Auto focus option indicator
     * @const {string}
     */
    const HERO_BANNER_SEARCH_AUTO_FOCUS = '[data-autofocus="true"]';

    /**
     * Header search open/active class
     * @const {string}
     */
    const HERO_BANNER_SEARCH_ACTIVE_CLASS =
        'hero-banner-search-wrapper--active';

    /**
     * Header search has input class
     * @const {string}
     */
    const HERO_BANNER_SEARCH_HAS_INPUT_CLASS =
        'hero-banner-search-wrapper--has-input';

    /**
     * Create a new HeaderSearch
     * @param {HTMLElement} heroBannerSearch - The wrapping HTML element of the heroBannerSearch
     * @class
     */
    class HeaderSearch {
        constructor(heroBannerSearchWrapper) {
            this.heroBannerSearchWrapper = heroBannerSearchWrapper;
            this.heroBannerSearch = heroBannerSearchWrapper.querySelector(
                HERO_BANNER_SEARCH_BODY_SELECTOR
            );

            // HeaderSearch isnt always a Modal so use it as a composite rather than as a parent
            // this.modalHandler = new Modal(heroBannerSearchWrapper);

            // Attach event handlers to open
            heroBannerSearchWrapper
                .querySelectorAll(HERO_BANNER_SEARCH_OPEN_ACTION_SELECTOR)
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.openSearch();
                    });
                });

            // Attach event handlers to open
            heroBannerSearchWrapper
                .querySelectorAll(HERO_BANNER_SEARCH_TOGGLE_ACTION_SELECTOR)
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.toggleSearch();
                    });
                });

            // Attach event handlers to close
            heroBannerSearchWrapper
                .querySelectorAll(HERO_BANNER_SEARCH_CLOSE_ACTION_SELECTOR)
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.closeSearch();
                    });
                });

            // Attach event handlers to clear
            heroBannerSearchWrapper
                .querySelectorAll(HERO_BANNER_SEARCH_CLEAR_ACTION_SELECTOR)
                .forEach((element) => {
                    element.addEventListener('click', () => {
                        this.clearSearch();
                    });
                });

            const primaryInput = heroBannerSearchWrapper.querySelector(
                HERO_BANNER_SEARCH_INPUT_SELECTOR
            );

            this.primaryInput = primaryInput;

            if (primaryInput) {
                primaryInput.addEventListener('input', (e) => {
                    this._handleInputChange(e);
                });
                primaryInput.addEventListener('change', (e) => {
                    this._handleInputChange(e);
                });
                // if (this._isFadeIn()) {
                //     primaryInput.addEventListener('blur', (e) => {
                //         if (e.currentTarget.contains(e.relatedTarget)) {
                //             this._handleFadeInBlur(e);
                //         }
                //     });
                // }
            }
        }

        /**
         * Open the search and handles extras like setting up modal ally and focus.
         */
        openSearch() {
            if (!this.isOpen()) {
                // Add CSS class to activate styling
                this.heroBannerSearchWrapper.classList.add(
                    HERO_BANNER_SEARCH_ACTIVE_CLASS
                );

                // If the search is configured to auto focus do it - must be after the ally setup otherwise focus restore wont function correctly
                if (
                    this.heroBannerSearchWrapper.matches(
                        HERO_BANNER_SEARCH_AUTO_FOCUS
                    )
                ) {
                    this.heroBannerSearchWrapper
                        .querySelector(HERO_BANNER_SEARCH_INPUT_SELECTOR)
                        .focus();
                }
            }
        }

        /**
         * Function to open or close the search depending on if open or not already
         */
        toggleSearch() {
            if (this.isOpen()) {
                this.closeSearch();
            } else {
                this.openSearch();
            }
        }

        /**
         * Closes the modal and deactivates any modal ally and media watch
         */
        closeSearch() {
            if (this.isOpen()) {
                // Remove CSS class to deactivate styling
                this.heroBannerSearchWrapper.classList.remove(
                    HERO_BANNER_SEARCH_ACTIVE_CLASS
                );
            }
        }

        clearSearch() {
            // Clear the input field
            const input = this.heroBannerSearchWrapper.querySelector(
                HERO_BANNER_SEARCH_INPUT_SELECTOR
            );
            input.value = '';
            input.dispatchEvent(new window.Event('change'));

            // Remove the 'has input' class which makes the X show
            this.heroBannerSearchWrapper.classList.remove(
                HERO_BANNER_SEARCH_HAS_INPUT_CLASS
            );

            // Reset focus to the input as the X will now hide
            this.heroBannerSearchWrapper
                .querySelector(HERO_BANNER_SEARCH_INPUT_SELECTOR)
                .focus();
        }

        // _handleFadeInBlur() {
        //     if (!this.heroBannerSearchWrapper.matches(':focus-within')) {
        //         this.closeSearch();
        //     }
        // }

        /**
         * Function to check if the search is currently open
         */
        isOpen() {
            return this.heroBannerSearchWrapper.matches(
                `.${HERO_BANNER_SEARCH_ACTIVE_CLASS}`
            );
        }

        /**
         * Function to handle the input change, adds a class to root to identify if text content exists or not
         */
        _handleInputChange(e) {
            const { target } = e;
            if (target.value !== '') {
                this.heroBannerSearchWrapper.classList.add(
                    HERO_BANNER_SEARCH_HAS_INPUT_CLASS
                );

                this.primaryInput.focus();
            } else {
                this.heroBannerSearchWrapper.classList.remove(
                    HERO_BANNER_SEARCH_HAS_INPUT_CLASS
                );
            }
        }
    }

    // Find all components (should only be one) and created handler objects
    const heroBannerSearch = document.querySelectorAll(
        HERO_BANNER_SEARCH_SELECTOR
    );
    heroBannerSearch.forEach((item) => {
        // Create a new item to modify
        const DOMItem = item;

        // Attach the class instance to our DOMItem
        if (!DOMItem.heroBannerSearch) {
            DOMItem.heroBannerSearch = new HeaderSearch(item);
        }
    });
}

_heroBannerSearch();
